import { createGlobalStyle as t } from "styled-components";
import "./what-input-t20lbRTY.js";
import { c as e } from "./style-ImpGK6sv.js";
const r = t`
  *,
  *::before,
  *::after {
    box-sizing: border-box; // Width is not affected by padding or border
  }

  *:focus {
    outline: 1px solid ${e.focus};
    outline-offset: 2px;
  }

  // What input?
  // https://github.com/ten1seven/what-input
  //
  // Do not show outline on (subsequent) mouse and touch focus event, just on keyboard event
  [data-whatintent='mouse'],
  [data-whatintent='touch'] {
    *:focus {
      outline: none !important;
    }
  }

  html {
    line-height: 1.15; // Correct the line height in all browsers.
    font-size: 100%; // Display proper font size if user adjusts the text size in the browser
    scroll-behavior: smooth; // won't work on IE, needs to be fixed
    -webkit-text-size-adjust: 100%; // Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS
    -ms-text-size-adjust: 100%; // As line above
    -ms-overflow-style: scrollbar; // Force scrollbars to not overlap the content in IE and Edge
    -webkit-tap-highlight-color: ${e.transparent}; // Change the default tap highlight
    -webkit-font-smoothing: antialiased; // Correct the font boldness in all browser,MAC specific issue
  }

  body {
    counter-reset: listicle-counter; /* this is connected to LISTICLE component */
    background-color: ${e.white};
    line-height: 1;
    color: ${e.black};
  }

  html, body {
    margin: 0;
    border: 0;
    padding: 0;
    vertical-align: baseline;
    font: inherit;
    font-size: 100%;
  }

  :root {
    --z-index-base: 100;
  }

  // Avoid 300ms click delay on touch devices that support the \`touch-action\` CSS property
  a,
  area,
  button,
  [role='button'],
  input,
  label,
  select,
  summary,
  textarea {
    touch-action: manipulation;
  }

  a {
    text-decoration: none;
    color: inherit;
    -webkit-text-decoration-skip: objects; // Remove gaps in links underline in iOS 8+ and Safari 8+
  }

  // Correct the inability to style clickable types in iOS and Safari
  button,
  [type='button'],
  [type='submit'] {
    -webkit-appearance: button;
    color: inherit;
    font: inherit;
  }

  // Remove inner border and padding from Firefox, but don't restore the outline like Normalize
  button::-moz-focus-inner,
  [type='button']::-moz-focus-inner,
  [type='reset']::-moz-focus-inner,
  [type='submit']::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  // Correct the cursor style of increment and decrement buttons in Chrome
  [type='number']::-webkit-inner-spin-button,
  [type='number']::-webkit-outer-spin-button {
    height: auto;
  }

  [type='search'] {
    -webkit-appearance: none;
    // Override the extra rounded corners on search inputs in iOS
    outline-offset: -2px; // Correct the outline style in Safari
  }

  // Remove the inner padding and cancel buttons in Chrome and Safari on macOS
  [type='search']::-webkit-search-cancel-button,
  [type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  // Suppress the focus outline on elements that cannot be accessed via keyboard
  [tabindex='-1']:focus {
    outline: none !important;
  }
`;
export {
  r as G
};
